import $ from 'jquery';

$.addInit(function(context) {
	var base = '.i-desc-click';

	$(base, context).each(function(){
		var component = $(this);
		var modal = $('#resume').closest('.b-modal');

		component.on('click', function() {
			var text = $(this).data('structure');
			var isInput = $(this).data('input');

			modal.on('ajaxAfterOpen', function() {
				if (isInput) {
					modal.find('.i-desc-message').val(text);
				} else {
					modal.find('.i-desc-message').text(text);
				}
			});
		});
	});
});
